import { computed, Injectable } from '@angular/core';
import { menuItems, navigateFn } from '@softline/application';
import { authorizationFn } from '@softline/auth';
import { SOFTLINE_PERMISSION_BUCHUNGSBRIEF } from '../buchungsbrief.shared';
import { FreigabeAddOn } from '@softapps/fibu/freigabe/api';

@Injectable()
export class BuchungsbriefFreigabeListAddOn extends FreigabeAddOn {

  private isAuthorized = authorizationFn();
  private navigate = navigateFn();

  constructor() {
    super();
    menuItems(() => {
      const hostParams = this.hostParams()
      if (!hostParams
        || !this.isAuthorized(SOFTLINE_PERMISSION_BUCHUNGSBRIEF)())
        return [];
      return [{
        type: 'execute',
        name: '#BUCHUNGSBRIEF.ADD_ON.TITLE',
        title: '#BUCHUNGSBRIEF.ADD_ON.TITLE',
        icon: 'fa-regular fa-envelope-open-text',
        outlet: 'action',
        canExecute: computed(() =>{
          const selected = hostParams.selected();
          return selected?.detail?.korrekturMoeglich;
        }),
        execute: async () => {
          const selected = hostParams.selected();
          await this.navigate(['/buchungsbrief', selected?.detail?.idkopferw], { origin: true });
        }
      }]
    })
  }
}
